<script setup lang="ts">
import { computed } from 'vue'
import { getBetDetails, useBetslip } from '@nsftx/seven-client-retail-vue-sgp'
import type { Bet } from '@nsftx/seven-client-retail-vue-integrator'
import STTicketCheckDetailsBetSummaryItem from './STTicketCheckDetailsBetSummaryItem.vue'

interface TicketCheckDetailsBetSummaryProps {
  bet: Bet
}

const { bet } = defineProps<TicketCheckDetailsBetSummaryProps>()

const { betslipCurrency } = useBetslip()
const betDetails = getBetDetails(bet)

const betSummaryList = computed(() => [
  {
    id: 'ticketPayment',
    translation: 'betslip_payment',
    amount: betDetails.payment,
    show: true
  },
  {
    id: 'ticketPossiblePayout',
    translation: 'betslip_possible_payout',
    amount: betDetails.possiblePayout,
    show: betDetails.isStatusOpen
  },
  {
    id: 'ticketStake',
    translation: 'betslip_stake',
    amount: betDetails.stake,
    show: true
  },
  {
    id: 'ticketPayinTax',
    translation: 'betslip_payin_tax',
    amount: betDetails.payinTax,
    show: true
  },
  {
    id: 'ticketPossibleWinnings',
    translation: 'betslip_possible_winnings',
    amount: betDetails.winnings,
    show: betDetails.isStatusWon
  },
  {
    id: 'ticketPayoutTax',
    translation: 'betslip_payout_tax',
    amount: betDetails.payoutTax,
    show: betDetails.isStatusWon
  },
  {
    id: 'ticketPayout',
    translation: 'betslip_payout',
    amount: betDetails.payout,
    show: betDetails.isStatusWon
  }
])
</script>

<template>
  <div class="st-ticket-check-details-bet-summary st-d-flex-column sc-pt-3">
    <div v-for="{ id, translation, amount, show } in betSummaryList" :key="id">
      <STTicketCheckDetailsBetSummaryItem
        v-if="show && amount"
        :text="$t(translation)"
        :amount
        :currency="betslipCurrency"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.st-ticket-check-details-bet-summary {
  font-size: 0.9rem;
}
</style>
